export const portalLocales = ['ca', 'de', 'en', 'es', 'eu', 'fr', 'gl', 'it', 'nl', 'pt'] as const;

/** Portal locales extended with BCP47 variants for standalone donation integrations */
export const portalLocalesExtended = [
	'ca',
	'ca-ES',
	'de',
	'de-DE',
	'en',
	'en-EN',
	'en-US',
	'en-GB',
	'es',
	'es-ES',
	'eu',
	'eu-ES',
	'fr',
	'fr-FR',
	'gl',
	'gl-ES',
	'it',
	'it-IT',
	'nl',
	'nl-NL',
	'pt',
	'pt-PT',
	'pt-BR',
] as const;

// Reexport for typescript to be satisfied
export type PortalLocaleExtended = (typeof portalLocalesExtended)[number];

/** Portal locales extended with BCP47 variants for standalone donation integrations */
export const portalLocaleExtendedToPortalLocale: Record<PortalLocaleExtended, PortalLocale> = {
	'ca': 'ca',
	'ca-ES': 'ca',
	'de': 'de',
	'de-DE': 'de',
	'en': 'en',
	'en-EN': 'en', // although not a valid BCP47 code, some browsers return this for English
	'en-US': 'en',
	'en-GB': 'en',
	'es': 'es',
	'es-ES': 'es',
	'eu': 'eu',
	'eu-ES': 'eu',
	'fr': 'fr',
	'fr-FR': 'fr',
	'gl': 'gl',
	'gl-ES': 'gl',
	'it': 'it',
	'it-IT': 'it',
	'nl': 'nl',
	'nl-NL': 'nl',
	'pt': 'pt',
	'pt-PT': 'pt',
	'pt-BR': 'pt',
};

export type PortalLocale = (typeof portalLocales)[number];

/** SDG names in English, used by backoffice campaign forms */
export const sdgNames: Record<number, string> = {
	1: 'No Poverty',
	2: 'Zero Hunger',
	3: 'Good Health and Well-being',
	4: 'Quality Education',
	5: 'Gender Equality',
	6: 'Clean Water and Sanitation',
	7: 'Affordable and Clean Energy',
	8: 'Decent Work and Economic Growth',
	9: 'Industry, Innovation and Infrastructure',
	10: 'Reduced Inequalities',
	11: 'Sustainable Cities and Communities',
	12: 'Responsible Consumption and Production',
	13: 'Climate Action',
	14: 'Life Below Water',
	15: 'Life on Land',
	16: 'Peace, Justice and Strong Institutions',
	17: 'Partnerships for the Goals',
};
